import { render, staticRenderFns } from "./HerbicideStatistics.vue?vue&type=template&id=4aafbd81&"
import script from "./HerbicideStatistics.vue?vue&type=script&lang=js&"
export * from "./HerbicideStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports